import { RADAR_PERMISSION } from "../utils/clubRoles";

// The club permission catalogue as the frontend knows it. It mirrors the
// backend seed (users/management/commands/seed_roles_permissions.py) and the
// whitelist in ClubRoleViewSet.available_permissions — keep the three in step.
//
// Reordered/trimmed with the V3 permissions gate (B9, "vier bauen, vier
// streichen"):
//   added   manage_document_templates, remove_staff
//           (two more were proposed and dropped by Marin on 2026-08-05:
//           share_pitches, because the product has no pitch-share surface to
//           gate, and sign_contracts, because both candidate surfaces serve
//           the agency side too and a contract is signed by both parties —
//           a club-only right would have locked agents out of signing)
//   struck  accept_tenders (duplicate of accept_pitches),
//           share_pitches_head_scouting / _sporting_director / _scout_team
//           (collapsed into share_pitches), contact_scouts_other_clubs,
//           contact_head_scout, internal_contact_everyone (internal contact is
//           canonically free), delete_user (replaced by remove_staff — the old
//           codename is struck, not inherited)
// Every entry below is enforced server-side and switchable in the club's
// Roles & Permissions hub, grouped there into the six sections of the gate.
export const PERMISSIONS = {
  // Requests
  VIEW_TENDERS: "view_tenders",
  CREATE_TENDERS: "create_tenders",
  EDIT_TENDERS: "edit_tenders",
  DELETE_TENDERS: "delete_tenders",
  // Pitches
  VIEW_PITCHES: "view_pitches",
  ACCEPT_PITCHES: "accept_pitches",
  // Contracts & documents
  MANAGE_DOCUMENT_TEMPLATES: "manage_document_templates",
  // Squad & scouting
  EDIT_SQUAD: "edit_squad",
  ACCESS_RADAR: RADAR_PERMISSION,
  // Communication
  CONTACT_CLUB: "contact_club",
  CONTACT_AGENTS: "contact_agents",
  TALK_TO_ORGANIZER: "talk_to_organizer",
  // Team & permissions
  INVITE_NEW_STAFF: "invite_new_staff",
  REMOVE_STAFF: "remove_staff",
  EDIT_ROLES: "edit_roles",
};
